var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChairIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 51.685 62",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".chair_icon_svg__a{fill:none;stroke:inherit;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    "data-svg-primary": "stroke"
  }, /*#__PURE__*/React.createElement("path", {
    className: "chair_icon_svg__a",
    d: "M29.138 41.772l10.315 3.073M.995 18.589H5.43a1 1 0 01.969.988v3.865h-5.4A1 1 0 010 22.449v-2.872a1 1 0 01.995-.988zM6.399 23.442v10.3a2.534 2.534 0 002.566 2.566M48.671 23.443h-5.4v-3.865a1 1 0 01.988-.988h4.431a1 1 0 01.995.994v2.87a1 1 0 01-.995.995zM43.267 23.442v10.3a2.566 2.566 0 01-2.566 2.566"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "chair_icon_svg__a",
    width: 27.922,
    height: 27.922,
    rx: 5.1,
    transform: "translate(10.872)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "chair_icon_svg__a",
    width: 31.736,
    height: 6.469,
    rx: 2.86,
    transform: "translate(8.965 33.079)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "chair_icon_svg__a",
    d: "M20.509 39.548h8.648v5.518h-8.648zM23.322 27.922h3.022v5.157h-3.022z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "chair_icon_svg__a",
    cx: 2.889,
    cy: 2.889,
    r: 2.889,
    transform: "translate(8.218 54.222)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "chair_icon_svg__a",
    cx: 2.889,
    cy: 2.889,
    r: 2.889,
    transform: "translate(21.941 54.222)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "chair_icon_svg__a",
    cx: 2.889,
    cy: 2.889,
    r: 2.889,
    transform: "translate(35.671 54.222)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "chair_icon_svg__a",
    d: "M24.83 54.222v-9.155M11.069 54.221v-1.387a2.971 2.971 0 012.978-2.978H35.62a2.971 2.971 0 012.971 2.978v1.388"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChairIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chair_icon.5017bccf045eeaff7a14082748e48cb4.svg";